import React from "react";
import styled from "styled-components";
import { siteColors } from "../constants/colors";
import { allNavItems } from "./header";
import _ from "lodash";
import { Link } from "gatsby";

const FooterContainer = styled.footer`
  margin-top: 1.5em;
  padding-top: 0.75em;
  padding-bottom: 0.5em;
  padding-left: 0.75em;
  color: ${ siteColors.light };
  background-color: ${ siteColors.darker };
`;

const BottomBarContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 3em;
  align-items: start;
  max-width: fit-content;
  margin: 0 auto;
`;

const FooterTitle = styled.h1`
  font-size: 1.2em;
  margin: 0;
`;

const BottomNavContainer = styled.div`
  width: 100%;
  min-width: 0;
  word-break: break-word;
`;

const BottomNavItem = styled(Link)`
  font-family: georgia, serif ;
  color: ${ siteColors.light };
  padding-right: 1em;
  white-space: nowrap;
  overflow: visible;
  text-decoration: None;
`;

const CopyrightContainer = styled.div`
  padding-top: 0.5em;
  padding-right: 0.5em;
  text-align: right;
  font-size: 0.75em;
  color: ${ siteColors.light };
`;

const Footer = ({ siteTitle }) => (
  <FooterContainer>
    <BottomBarContainer>
      <FooterTitle>{siteTitle}</FooterTitle>
      <BottomNavContainer>
        {_.map(allNavItems, (item) =>
          <BottomNavItem key={item.label}
            component={Link}
            to={item.to}
          >{item.label}</BottomNavItem>

        )}
      </BottomNavContainer>
    </BottomBarContainer>
    <CopyrightContainer>
      © {new Date().getFullYear()} Notional Pipe Incorporated
    </CopyrightContainer>
  </FooterContainer>
);

export default Footer;
